import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from "../environments/environment";
import { User, Role, UsersResponse, UserFilters, ImpersonationResponse, StopImpersonationResponse, UserMutationResponse, UserSuccessResponse } from '../_models/user.model';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(private http: HttpClient) { }

  getUsers(page: number = 1, limit: number = 100, filters: UserFilters = {}): Observable<UsersResponse> {
    let params = new HttpParams()
      .set('page', page.toString())
      .set('limit', limit.toString());
    
    if (filters.search) {
      params = params.set('search', filters.search);
    }
    if (filters.email) {
      params = params.set('email', filters.email);
    }
    
    return this.http.get<UsersResponse>(`${environment.apiUrl}/users`, { params });
  }

  getUser(id: number, includeDivisions: boolean = false): Observable<User> {
    let params = new HttpParams();
    
    if (includeDivisions) {
      params = params.set('includeDivisions', 'true');
    }
    
    return this.http.get<User>(`${environment.apiUrl}/users/${id}`, { params });
  }

  createUser(user: Partial<User>): Observable<UserMutationResponse> {
    return this.http.post<UserMutationResponse>(`${environment.apiUrl}/users`, user);
  }

  updateUser(id: number, user: Partial<User>): Observable<UserMutationResponse> {
    return this.http.put<UserMutationResponse>(`${environment.apiUrl}/users/${id}`, user);
  }

  deleteUser(id: number): Observable<UserSuccessResponse> {
    return this.http.delete<UserSuccessResponse>(`${environment.apiUrl}/users/${id}`);
  }

  getRoles(): Observable<{ roles: Role[] }> {
    return this.http.get<{ roles: Role[] }>(`${environment.apiUrl}/roles`);
  }

  impersonateUser(userId: number): Observable<ImpersonationResponse> {
    return this.http.post<ImpersonationResponse>(`${environment.apiUrl}/users/${userId}/impersonate`, {});
  }

  stopImpersonation(): Observable<StopImpersonationResponse> {
    return this.http.post<StopImpersonationResponse>(`${environment.apiUrl}/users/stop-impersonation`, {});
  }
}
